import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import {ACTIVITY_TYPE} from "../../../../common/Constants";

class MasterKSUModifying extends Component {
    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Master KSU"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleInput
                                id="input_text_kode_ksu"
                                name="kodeKSU"
                                label="Kode KSU"
                                readOnly={this.props.activityType === ACTIVITY_TYPE.UPDATE}
                                mandatory
                                errorMessage={this.props.errors.kodeKSU}
                                value={this.props.controls.kodeKSU.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_ksu"
                                name="name"
                                label="Nama KSU"
                                mandatory
                                errorMessage={this.props.errors.name}
                                value={this.props.controls.name.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_kategori"
                                box="search"
                                name="category"
                                label="Kategori"
                                mandatory
                                isClearable
                                errorMessage={this.props.errors.category}
                                options={this.props.dataKategoriDDL}
                                value={this.props.controls.category.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_satuan"
                                box="search"
                                name="satuan"
                                label="Satuan"
                                mandatory
                                isClearable
                                errorMessage={this.props.errors.satuan}
                                options={this.props.dataSatuanDDL}
                                value={this.props.controls.satuan.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default withFormGroup(MasterKSUModifying);